import React from 'react';
import { withSitecoreContext, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import './styles.css';
import RenderingStyling from '../../../lib/RenderingStyling';
import useMasthead from './mastheadHook.js';

const MastheadSliderContainer = ({
  fields,
  rendering,
  sitecoreContext,
  'masterhead-elements': mastheadElements,
}) => {
  const isEditorMode = sitecoreContext.pageEditing;

  const uniqueId = rendering.uid;

  const playDuration = fields?.MastheadPlayDuration?.value;
  const slideDuration = playDuration ? playDuration : 7;

  const headerHeight = fields?.HeaderHeight?.fields?.value?.value ?? '';
  const hideBreadcrumbs = fields?.HideBreadcrumbs?.value == true ? 'hide-breadcrumbs' : '';

  useMasthead();

  return (
    <div
      className={`c-header nav-margin ${hideBreadcrumbs} ${headerHeight} ${
        isEditorMode ? 'is-experience-editor' : ''
      }`}
    >
      <div
        id={uniqueId}
        {...RenderingStyling(rendering.componentName)}
        className={`o-widget c-masthead ${isEditorMode ? 'exp-editor' : ''}`}
      >
        <div className="c-masthead__slider" slider-delay={slideDuration}>
          <Placeholder name="jss-masterhead-elements" rendering={rendering} />
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(MastheadSliderContainer);
